import React from 'react';
import { FormattedMessage } from 'react-intl';

const Footer = ({ classicHeader, isAWare, updateCookies, handleNavClick }) => {
  return (
    <footer id="footer">
      <div className={'main-padding' + (classicHeader ? '' : 'px-lg-5')}>
        <div className="row">
          <div className="col-lg-6 text-center text-lg-start">
            <p className="mb-3 mb-lg-0 text-white">
              <FormattedMessage
                id="footer-copyright"
                defaultMessage="© 2023 Go-Numerik. Tous droits réservés"
              />
            </p>
          </div>
          <div className="col-lg-6 text-white">
            <ul className="nav nav-separator  justify-content-center justify-content-lg-end">
              <li className="nav-item">
                <a
                  className="nav-link"
                  data-bs-toggle="modal"
                  data-bs-target="#terms-policy"
                  href="#terms-policy">
                  <FormattedMessage
                    id="footer-terms-policies"
                    defaultMessage="Terms & policies"
                  />
                </a>
              </li>
              {/* <li className="nav-item">
                <a
                  className="nav-link"
                  data-bs-toggle="modal"
                  data-bs-target="#disclaimer"
                  href="#disclaimer">
                  Disclaimer
                </a>
              </li> */}
            </ul>
          </div>
        </div>
        {!isAWare && (
          <div className="cookies fixed-bottom main-padding">
            <div className="d-flex">
              <div className="cookies-image-box">
                <img
                  src="/images/cookies.png"
                  className="cookies-image"
                  alt="cookies image"
                />
              </div>
              <div className="cookies-desc text-white">
                <FormattedMessage
                  id="footer-cookies-text"
                  defaultMessage="Accept"
                />
              </div>
            </div>
            <div className="h-100 d-flex align-items-center justify-content-center button-wrapper">
              <a
                href="#contact"
                className="btn btn-outline-primary rounded-pill shadow-none smooth-scroll mt-2"
                onClick={(e) => {
                  e.preventDefault();
                  updateCookies('isCookiesAware', true);
                }}>
                <FormattedMessage
                  id="footer-accpet-cookies"
                  defaultMessage="Accept cookies"
                />
              </a>
            </div>
          </div>
        )}
      </div>
    </footer>
  );
};

export default Footer;
